import React from 'react'
import { Box, Flex, ThemeColors, styled } from '@chilipiper/design-system'

type Props = {
  isChecked: boolean
  isDisabled: boolean
}

export const CustomSwitch = ({ isChecked, isDisabled }: Props) => {
  return (
    <Flex
      style={{ pointerEvents: 'none' }}
      onClick={e => e.stopPropagation()}
      alignItems='center'
      bg={getBgColor({ isChecked, isDisabled })}
      borderRadius={8}
      flexShrink={0}
      h={4}
      p={1}
      w={6}
    >
      <ToggleSwitch
        bg='fg/major-on-color'
        borderRadius='full'
        flexShrink={0}
        h={2}
        isChecked={isChecked}
        w={2}
      />
    </Flex>
  )
}

const getBgColor = ({
  isChecked,
  isDisabled,
}: {
  isChecked: boolean
  isDisabled: boolean
}): ThemeColors => {
  if (!isChecked) {
    if (isDisabled) {
      return 'bg/disabled'
    }

    return 'bg/select-item-unchecked'
  }

  if (isDisabled) {
    return 'bg/select-item-major-checked-disabled'
  }

  return 'bg/select-item-major-checked'
}

const ToggleSwitch = styled(Box)<{ isChecked: boolean }>`
  transform: ${({ isChecked }) => (isChecked ? 'translateX(100%)' : 'translateX(0)')};
  transition: transform 0.2s;
`
